




















































































































































































































































































































































































import { $eventsBus } from "@/main";
import BaseChart from "@/app/shared/components/base/BaseChart.js";
import draggable from "vuedraggable";
import utils from "@/app/shared/utils/utils.js";

export default {
  name: "PartsMixerTimeline",
  components: { BaseChart, draggable },
  mixins: [utils],
  props: {
    zoom: {
      type: Number,
      default: 100,
    },
  },
  data: function () {
    return {
      drag: false,
      isTimelineScrollbarVisible: false,
      chartData: null,
      isShowChart: false,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              display: false,
              gridLines: {
                display: false,
                drawOnChartArea: false,
              },
            },
          ],
          yAxes: [
            {
              display: false,
              gridLines: {
                display: false,
                drawOnChartArea: false,
              },
            },
          ],
        },
        tooltips: {
          enabled: false,
        },
        elements: {
          point: {
            radius: 0,
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
      },
      //PlayheadDrag parameters
      lastPlayheadDragResponseTime: 0,
      collectedMovementX: 0,
      currentMovmentXToShow: 0,
      isTryingToSeekNow: false,
      isPlayheadDragging: false,
    };
  },
  computed: {
    items() {
      return this.$store.state.items;
    },
    itemsToShow: function () {
      return this.$store.state.items.filter((i) => !i.hidden);
    },
    contentDuration: function () {
      let duration = 0;
      this.$store.state.items
        .filter((i) => !i.hidden)
        .forEach((item) => {
          duration += item.duration;
        });
      return duration;
    },
    allPartsToShow: function () {
      return this.$store.state.items
        .filter((i) => !i.hidden)
        .reduce((acc, val) => acc.concat(val.parts), []);
    },
    allParts: function () {
      return this.$store.state.items.reduce(
        (acc, val) => acc.concat(val.parts),
        []
      );
    },
    mixedPartsDuration: function () {
      let duration = 0;
      this.$store.state.mixedParts.forEach((part) => {
        duration += part.finishTime - part.startTime;
      });
      return duration;
    },
    mixedParts: {
      get: function () {
        return this.$store.state.mixedParts;
      },
      set: function (mixedParts) {
        this.$store.commit("mixedParts", mixedParts);
      },
    },
    isMixerStep: {
      get: function () {
        return this.$store.state.isMixerStep;
      },
      set: function (isMixerStep) {
        this.$store.commit("isMixerStep", isMixerStep);
      },
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    selectedPart: {
      get: function () {
        return this.$store.state.selectedPart;
      },
      set: function (part) {
        this.$store.commit("changeSelectedPart", part);
      },
    },
    contentVideoCurrentTime: {
      get: function () {
        return this.$store.state.contentVideoCurrentTime;
      },
      set: function (value) {
        this.$store.commit("contentVideoCurrentTime", value);
      },
    },
    dragOptions() {
      return {
        animation: 200,
        group: "parts",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    audioParameters: function () {
      return this.$store.state.audioParameters;
    },
  },
  watch: {
    previewItem: function () {
      this.tryUpdateGraphData(this.previewItem);
    },
    mixedParts: function () {
      if (this.mixedParts.length !== 0) {
        if (this.mixedParts.length === 1) {
          this.selectedPart = this.mixedParts[0];
          this.contentVideoCurrentTime = 0;
          $eventsBus.$emit("setContentTime", 0);
        }
      } else {
        this.selectedPart = null;
        this.contentVideoCurrentTime = 0;
        $eventsBus.$emit("setContentTime", 0);
        $eventsBus.$emit("setVideoPaused", true);
      }

      this.$store.commit(
        "changeSelectItem",
        !!this.selectedPart
          ? this.items.find((i) => i.id === this.selectedPart.parentItemInfo.id)
          : null
      );
    },
  },
  created() {
    $eventsBus.$on("contentTimeUpdated", () => {
      this.currentMovmentXToShow = 0;
      this.isTryingToSeekNow = false;
    });
  },
  mounted() {
    if (this.$refs.mixerTimeline) {
      this.isTimelineScrollbarVisible =
        this.$refs.mixerTimeline.scrollHeight >
        this.$refs.mixerTimeline.parentElement.clientHeight;
    }
    this.tryUpdateGraphData(this.previewItem);
  },
  updated() {
    if (this.$refs.mixerTimeline) {
      this.isTimelineScrollbarVisible =
        this.$refs.mixerTimeline.scrollHeight >
        this.$refs.mixerTimeline.parentElement.clientHeight;
    }
  },
  methods: {
    tryUpdateGraphData(item) {
      if (!item || !item.autocutParameters.isReadyToAutocut) {
        setTimeout(() => {
          this.tryUpdateGraphData(this.previewItem);
        }, 1000);
        return;
      }
      if (item.bitrateGraph) {
        this.updateGraphData(item);
      } else {
        this.axios
          .post(
            "/v2.0/autocut/getFramesInfo",
            {
              fileId: item.fileId,
              params: {
                partCount: item.autocutParameters.partsCount,
                duration: item.autocutParameters.partsDurations,
              },
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            item.bitrateGraph = response.data.bitrateGraph;
            this.updateGraphData(item);
          })
          .catch((erorr) => {
            console.error(erorr);
          });
      }
    },
    updateGraphData(item) {
      let data = [];
      item.bitrateGraph.forEach((point) => {
        data.push(point.pkt_size);
      });
      this.chartData = {
        labels: data,
        datasets: [
          {
            backgroundColor: "#f87979",
            data: data,
          },
        ],
      };
    },
    seekTime(event) {
      let allTime = this.mixedPartsDuration;
      let currentTargetRect = event.currentTarget.getBoundingClientRect();
      let eventOffsetX = event.pageX - currentTargetRect.left;
      let newTime = (eventOffsetX / currentTargetRect.width) * allTime;
      $eventsBus.$emit(
        "setContentTime",
        newTime < 0 ? 0 : newTime > allTime ? allTime : newTime
      );
    },
    startDragPlayhead(event) {
      $eventsBus.$emit("isPlayingForceDisable", true);
      window.onmousemove = this.movePlayhead.bind(event);
      window.onmouseup = this.stopDragPlayhead.bind(event);
      this.lastPlayheadDragResponseTime = Date.now();
      this.isPlayheadDragging = true;
    },
    movePlayhead(event) {
      event.preventDefault();
      this.collectedMovementX += event.movementX;

      this.lastPlayheadDragResponseTime = Date.now();
      this.changeTime(Date.now());
    },
    changeTime(responseTime) {
      if (this.collectedMovementX === 0 || this.isTryingToSeekNow) {
        return;
      }
      this.currentMovmentXToShow = this.collectedMovementX;
      if (responseTime - this.lastPlayheadDragResponseTime < 200) {
        setTimeout(() => {
          this.changeTime(responseTime + 200);
        }, 200);
        return;
      }
      let newTime = 0;
      newTime =
        this.contentVideoCurrentTime +
        (this.collectedMovementX /
          this.$refs.mixerTimelinePlayheadContainer.offsetWidth) *
          this.mixedPartsDuration;
      newTime = Math.floor(newTime * 100) / 100;
      newTime =
        newTime < 0
          ? 0
          : newTime > this.mixedPartsDuration
          ? this.mixedPartsDuration
          : newTime;
      if (newTime !== this.contentVideoCurrentTime) {
        $eventsBus.$emit("setContentTime", newTime);
        this.collectedMovementX = 0;
        this.isTryingToSeekNow = true;
      } else {
        this.collectedMovementX = 0;
        this.currentMovmentXToShow = 0;
        this.isTryingToSeekNow = false;
      }
    },
    stopDragPlayhead(event) {
      window.onmouseup = null;
      window.onmousemove = null;
      $eventsBus.$emit("isPlayingForceDisable", false);
      this.isPlayheadDragging = false;
    },
    selectItem(item) {
      this.$store.commit("changeSelectItem", item);
    },
    getItemByPart(part) {
      return this.itemsToShow.find((i) => i.id === part.parentItemInfo.id);
    },
    getPartThumbs(part) {
      let item = this.getItemByPart(part);
      let thumbs =
        item.thumbs.length === 0
          ? item.loadingParameters.localThumbs
          : item.thumbs;
      let startIndex = Math.ceil(
        (part.startTime * thumbs.length) / item.duration
      );
      let finishIndex = Math.floor(
        (part.finishTime * thumbs.length) / item.duration
      );

      if (startIndex < 0) {
        startIndex = 0;
      } else if (startIndex > thumbs.length - 1) {
        startIndex = thumbs.length - 1;
      }

      if (finishIndex < 0) {
        finishIndex = 0;
      } else if (finishIndex > thumbs.length - 1) {
        finishIndex = thumbs.length - 1;
      }

      return thumbs
        .slice(startIndex, finishIndex + 1)
        .map(
          (thumb) => (item.thumbs.length === 0 ? "" : this.$baseURL) + thumb
        );
    },
    getDurationOfPreviousItemsToShowByPart(part) {
      let item = this.itemsToShow.find((i) => i.id === part.parentItemInfo.id);
      return this.getDurationOfPreviousItemsToShow(item);
    },
    getDurationOfPreviousItemsToShow(item) {
      let itemIndex = this.itemsToShow.indexOf(item);
      if (itemIndex === -1) {
        return 0;
      }
      let allDuration = 0;
      for (let index = 0; index < itemIndex; index++) {
        allDuration += this.itemsToShow[index].duration;
      }
      return allDuration;
    },
    onAddMusicFile() {
      (<HTMLElement>this.$refs.fileInput).click();
    },
    onFileChanged(event: any) {
      let files: FileList = event.target.files;
      this.validateAndUploadFiles(files);
      event.target.value = "";
    },
    validateAndUploadFiles(files) {
      let result: File[] = [];
      const maxCount = 1;
      let maxIndex = files.length > maxCount ? maxCount : files.length;
      for (var i = 0; i < maxIndex; i++) {
        result.push(<File>files.item(i));
      }
      this.uploadFiles(result);
    },
    uploadFiles(files: File[]) {
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };

      let data = new FormData();
      for (var i = 0; i < files.length; i++) {
        let file = files[i];
        data.append("files[" + i + "]", file);
      }

      let route = "/v2.0/upload/uploadMedia";

      this.axios
        .post(route, data, config)
        .then((res) => {
          res.data.forEach((file) => {
            this.audioParameters.musicFile = {
              duration: file.duration,
              path: file.file,
              id: file.fileId,
              name: file.name,
            };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteMusic() {
      this.audioParameters.musicFile = null;
    },
    onDeletePart(part, partIndex) {
      this.mixedParts.splice(partIndex, 1);
      if (part === this.selectedPart) {
        this.selectedPart = this.mixedParts[0];
      }
      this.$forceUpdate();
      /*       if (this.mixedParts.length === 0) {
        this.isMixerStep = false;
        $eventsBus.$emit("setVideoPaused", true);
        $eventsBus.$emit("setContentTime", 0);
      } */
    },
    onEditPart(part) {
      if (this.isMixerStep) {
        this.isMixerStep = false;
        $eventsBus.$emit("setVideoPaused", true);
        $eventsBus.$emit("setContentTime", 0);
      }
      this.selectedPart = part;
    },
  },
};
